import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import "./ManageEditCamp.scss";
import { ChangeEvent, useRef, useState, useEffect } from "react";
import {
  SP_EDIT_FIELDS,
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  ROUTES,
  TOASTER_CONFIGS,
  TOAST_ERRORS,
} from "../../../Utilities/Constants/Constants";
import * as yup from "yup";
import {
  ADD_SCHOOLS_ERROR_MESSAGES,
  EDIT_UNIVERSITY_ERROR_MESSAGE,
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import { Field, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  S3DataGetApi,
  nullUndefinedEmptyCheck,
  numberOnlyWithDecimal,
} from "../../../Services/Helpers/Helper";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import backButton from "../../../../Assets/schools/back_button.svg";
import eyeIcon from "../../../../Assets/schools/eye.svg";
import uploadFile from "../../../../Assets/schools/upload.svg";
import upload_image from "../../../../Assets/schools/upload_image.svg";
import close from "../../../../Assets/schools/close.svg";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useSelector } from "react-redux";
import {
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { GoogleMap, Marker, MarkerF, useLoadScript, useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import RoomIcon from '@mui/icons-material/Room';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileViewerDialog from "../../../Shared/FileViewerDialog/FileViewerDialog";
import { format } from "date-fns";
import { store } from "../../../Services/Redux/Store/Store";
import { setLoader } from "../../../Services/Redux/Reducer/Reducer";
import { Autocomplete as MuiAutocomplete } from '@mui/material';


const libraries: any = ['places'];

const ManageEditCamp = () => {
  const { isLoaded }: any = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    libraries
  });
  const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';
  const formikRef = useRef<any>();
  const { id } = useParams();
  const [currentLocation, setCurrentLocation]: any = useState();
  const [mapEnabled, setMapEnabled] = useState(API_RESPONSE.TRUE);
  const [idFront, setIdFront] = useState<any>("");
  const [idBack, setIdBack] = useState<any>("");
  const [passportFront, setPassportFront] = useState<any>("");
  const [passportBack, setPassportBack] = useState<any>("");
  const [photo, setPhoto] = useState<any>("");
  const [certificate, setCertificate] = useState<any>([]);
  const [tradeLicense, setTradeLicense] = useState<any>("");
  const [emiratesList, setEmiratesList] = useState<any>([]);
  
  interface UnivercitysData {
    [key: string]: any;
  }
  const [TutorDetail, setTutorDetail] = useState<UnivercitysData>({
    [SP_EDIT_FIELDS.FIRST_NAME]: "",
    [SP_EDIT_FIELDS.LAST_NAME]: "",
    [SP_EDIT_FIELDS.LOCATION]: "",
    [SP_EDIT_FIELDS.WEBSITE_ADDRESS]: "",
    [SP_EDIT_FIELDS.EMAIL]: "",
    [SP_EDIT_FIELDS.PHONE_NUMBER]: "",
    [SP_EDIT_FIELDS.GENDER]: "",
    [SP_EDIT_FIELDS.DISCRIPTION]: "",
    [SP_EDIT_FIELDS.ABOUT_CAMP]: "",
    [SP_EDIT_FIELDS.DOB]: "",
    [SP_EDIT_FIELDS.EMIRATES]: "",
    [SP_EDIT_FIELDS.CITY]: "",
    [SP_EDIT_FIELDS.COUNTRY]: "",
    [SP_EDIT_FIELDS.ID]: "" ,
    [SP_EDIT_FIELDS.ID_FRONT]: "",
    [SP_EDIT_FIELDS.ID_BACK]: "",
    [SP_EDIT_FIELDS.PASSPORT]: "",
    [SP_EDIT_FIELDS.PASSPORT_FRONT]: "",
    [SP_EDIT_FIELDS.PASSPORT_BACK]: "",
    [SP_EDIT_FIELDS.PHOTO]: "",
    [SP_EDIT_FIELDS.CERTIFICATE]: [],
    [SP_EDIT_FIELDS.BANK_NAME]: "",
    [SP_EDIT_FIELDS.BANK_BRANCH_NAME]: "",
    [SP_EDIT_FIELDS.ACCOUNT_HOLDER_NAME]: "",
    [SP_EDIT_FIELDS.ACCOUNT_NO]: "",
    [SP_EDIT_FIELDS.SWIFT_CODE]: "",
    [SP_EDIT_FIELDS.IBAN_NO]: "",
    [SP_EDIT_FIELDS.STATE]: "",
    [SP_EDIT_FIELDS.TRADE_LICENSE]: "",
    [SP_EDIT_FIELDS.TRADE_ID]: "",
    [SP_EDIT_FIELDS.CAMP_NAME]: "",
    [SP_EDIT_FIELDS.ARABIC_CAMP_NAME]: "",
  });
  const inputRef = useRef<any>(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [imageBanner, setImageBanner] = useState<any>(null);
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState("");
  const currentYear = new Date().getFullYear();
  const [autocomplete, setAutocomplete] = useState<any>(null);

  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const shouldDisableYear = (year: any) => {
    return new Date(year).getFullYear() > currentYear;
  };

useEffect(() => {
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
  }).catch(() => {
  })
}, [])

  useEffect(() => {
    getTutorDetail();
    getEmiratesList();
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lng: longitude });
        },
      );
    }
  }, [])

  const [universityImages, setUniversityImages]: any = useState([]);

  const navigate = useNavigate();

  
  const getTutorDetail = () => {
    axiosInstance
      .get(API_END_POINTS.GET_RECREATIONAL_DETAIL + "?id=" + id + "&type=camp")
      .then((res) => {
        setTutorDetails(res.data.result.data[0]);
      });
  };

  const getEmiratesList = () => {
    axiosInstance.get(API_END_POINTS.EMIRATE_LIST).then((response) => {
      setEmiratesList(response?.data?.result?.data)
    }).catch(() => { })
  }

  const setTutorDetails = (data: any) => {
    setTutorDetail({
      [SP_EDIT_FIELDS.FIRST_NAME]: data?.profile_details?.firstname || "",
      [SP_EDIT_FIELDS.LAST_NAME]: data?.profile_details?.lastname || "",
      [SP_EDIT_FIELDS.CAMP_NAME]: data.campname,
      [SP_EDIT_FIELDS.ARABIC_CAMP_NAME]: data.arabic_camp_name ? data.arabic_camp_name : "",
      [SP_EDIT_FIELDS.LOCATION]: data.address,
      [SP_EDIT_FIELDS.STATE]: data.state,
      [SP_EDIT_FIELDS.WEBSITE_ADDRESS]: data.website_name ? data.website_name : "",
      [SP_EDIT_FIELDS.EMAIL]: data?.profile_details?.email,
      [SP_EDIT_FIELDS.PHONE_NUMBER]: data?.profile_details?.phone_number ? data?.profile_details?.phone_number : "",
      [SP_EDIT_FIELDS.GENDER]: data.gender ? data.gender : "",
      [SP_EDIT_FIELDS.DISCRIPTION]: data.description,
      [SP_EDIT_FIELDS.ABOUT_CAMP]: data.about_camp ? data.about_camp : "",
      [SP_EDIT_FIELDS.DOB]: data.dob ? data.dob : "",
      [SP_EDIT_FIELDS.EMIRATES]: data.emirate ? data.emirate : "",
      [SP_EDIT_FIELDS.CITY]: data.city ? data.city : "",
      [SP_EDIT_FIELDS.COUNTRY]: data?.country,
      [SP_EDIT_FIELDS.ID]: data.id ? data.emirates_id : "",
      [SP_EDIT_FIELDS.ID_FRONT]: data.emirates_front ? data.emirates_front : "",
      [SP_EDIT_FIELDS.ID_BACK]: data.emirates_back ? data.emirates_back : "",
      [SP_EDIT_FIELDS.PASSPORT]: data.immigrant_id ? data.immigrant_id : "",
      [SP_EDIT_FIELDS.PASSPORT_FRONT]: data.immigrant_front ? data.immigrant_front : "",
      [SP_EDIT_FIELDS.PASSPORT_BACK]: data.immigrant_back ? data.immigrant_back : "",
      [SP_EDIT_FIELDS.PHOTO]: data.profile_image ? data.profile_image : "",
      [SP_EDIT_FIELDS.PINCODE]: data.pincode ? data.pincode : "",
      [SP_EDIT_FIELDS.CERTIFICATE]: data.certificates ? data.certificates : [],
      [SP_EDIT_FIELDS.BANK_NAME]: data.bank_name ? data.bank_name : "",
      [SP_EDIT_FIELDS.BANK_BRANCH_NAME]: data.bank_branch_name ? data.bank_branch_name : "",
      [SP_EDIT_FIELDS.ACCOUNT_HOLDER_NAME]: data.account_holder_name ? data.account_holder_name : "",
      [SP_EDIT_FIELDS.ACCOUNT_NO]: data.bank_ac_number ? data.bank_ac_number : "",
      [SP_EDIT_FIELDS.SWIFT_CODE]: data.bank_ac_swift_code ? data.bank_ac_swift_code : "",
      [SP_EDIT_FIELDS.IBAN_NO]: data.bank_iban_number ? data.bank_iban_number : "",
      [SP_EDIT_FIELDS.TRADE_LICENSE]: data.trade_license ? data.trade_license : "",
      [SP_EDIT_FIELDS.TRADE_ID]: data.trade_id ? data.trade_id : "",
      
    });
    setImageBanner(data.academic_calendar);
    setIdFront(data.emirates_front);
    setIdBack(data.emirates_back);
    setPassportFront(data.immigrant_front);
    setPassportBack(data.immigrant_back);
    setPhoto(data.profile_image);
    setCertificate(data.certificates);
    setTradeLicense(data.trade_license);

    if (data.latitude)
      setCurrentLocation({ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) })
  };

  const addEditUniversityDetail = (payload: any) => {
    let payloadData = {
      id: id,
      ...payload,
    };
    axiosInstance.put(API_END_POINTS.EDIT_CAMPS_PROFILE, payloadData).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message, TOASTER_CONFIGS);
        navigate(-1);
      }
    }).catch((error) => { console.error(error) });
    
  };
  const [validNumber, setValidNumber] = useState(true);
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  
  const universityValidationSchema = yup.object({
    [SP_EDIT_FIELDS.FIRST_NAME]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.FIRST_NAME),

    
    [SP_EDIT_FIELDS.LOCATION]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.LOCATION_REQUIRED),

    [SP_EDIT_FIELDS.EMAIL]: yup
      .string()
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.EMAIL_REQUIRED),
    [SP_EDIT_FIELDS.PHONE_NUMBER]: yup
      .string()
      .required(ERROR_MESSAGES.PHONE_NUMBER),
    [SP_EDIT_FIELDS.DEGREES_AND_FEES]: yup.string(),
   
    [SP_EDIT_FIELDS.DISCRIPTION]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.DESCRIPTION_REQUIRED),

    [SP_EDIT_FIELDS.GENDER]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.GENDER),
   
  });

  const idFrontRef = useRef<HTMLInputElement | null>(null);
  const idBackRef = useRef<HTMLInputElement | null>(null);
  const passportFrontRef = useRef<HTMLInputElement | null>(null);
  const passportBackRef = useRef<HTMLInputElement | null>(null);
  const photoRef = useRef<HTMLInputElement | null>(null);
  const certificateRef = useRef<HTMLInputElement | null>(null);
  const tradeLicenseRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.UNIVERSITY_IMAGES,
      universityImages
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.ID_FRONT,
      idFront
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.ID_BACK,
      idBack
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.PASSPORT_FRONT,
      passportFront
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.PASSPORT_BACK,
      passportBack
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.PHOTO,
      photo
    );
    formikRef.current.setFieldValue(
      SP_EDIT_FIELDS.CERTIFICATE,
      certificate
    );
  }, [universityImages, idFront, idBack, passportFront, passportBack, photo, certificate]);

  const handleChange = async (event: any) => {
    const files = event.target.files;
    let typeValidation: any = Array.from(files).map((file: any) => {
      return file.type.split('/')[0] === "image"
    });
    try {
      if (universityImages.length + event.target.files.length <= 10 && !typeValidation.includes(false) && event.target.files.length !== 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          store.dispatch(setLoader(true));
          const uploadedImage = await S3DataGetApi(event);
          setTimeout(() => {
            setUniversityImages((schoolImages: any) => [
              ...schoolImages,
              uploadedImage,
            ]);
            store.dispatch(setLoader(false));
          }, 0);
        }
      } else {
        if (event.target.files.length !== 0)
          universityImages.length + event.target.files.length >= 10 ? toast.error(TOAST_ERRORS.IMAGES_LIMIT) : toast.error("Please upload only images");
      }
    } catch (error) {
      toast.error(`${TOAST_ERRORS.IMAGE_UPLOAD_ERROR}` + `${error}`);
    }
  };

  const handleFileUpload = async (event: any, type: string) => {
    try {
      if (event.target.files[0].type.split("/")[0] === "image") {
        store.dispatch(setLoader(true));
        const uploadedImage = await S3DataGetApi(event);
        switch (type) {
          case "idFront":
            setIdFront(uploadedImage);
            break;
          case "idBack":
            setIdBack(uploadedImage);
            break;
          case "passportFront":
            setPassportFront(uploadedImage);
            break;
          case "passportBack":
            setPassportBack(uploadedImage);
            break;
          case "photo":
            setPhoto(uploadedImage);
            break;
          case "certificate":
            setCertificate((prev: any) => [...prev, uploadedImage]);
            break;
          case "tradeLicense":
            setTradeLicense(uploadedImage);
            break;
          default:
            break;
        }
        store.dispatch(setLoader(false));
      } else if (event.target.files[0].type.split("/")[1] === "pdf") {
        store.dispatch(setLoader(true));
        const uploadedImage = await S3DataGetApi(event);
        switch (type) {
          case "certificate":
            setCertificate(uploadedImage);
            break;
          case "tradeLicense":
            setTradeLicense(uploadedImage);
            break;
        }
        store.dispatch(setLoader(false));
      }
    } catch (error) {
      toast.error(`${TOAST_ERRORS.IMAGE_UPLOAD_ERROR}` + `${error}`);
    }
  };


  const onUploadEventImage = async (event: any, eventName: string) => {
    try {
      if (event.target.files[0].type.split("/")[1] === "pdf") {
        store.dispatch(setLoader(true));
        const uploadedImage = await S3DataGetApi(event);
        setImageBanner(uploadedImage);
        store.dispatch(setLoader(false));
      } else {
      }
    } catch (error) { }
  };

  

  const handleDelete = (i: any) => () => {
    setCertificate(
      certificate.filter((item: any, index: any) => index !== i)
    );
  };

  const setCurrentLatLng = (latitude: any, longitude: any) => {
    setCurrentLocation({ lat: latitude, lng: longitude });
  }

  const getFormattedAddress = (lat: any, lng: any, formik: any, check: boolean) => {
    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
      if (status === "OK") {
        if (results[COMMON_CONSTANTS.ZERO]) {
          let filterCountry = results[COMMON_CONSTANTS.ZERO]?.address_components?.filter((res: any) => {
            return res.types[0] === 'country'
          });

          if (results[COMMON_CONSTANTS.ZERO]) {
            if (check) {
              formik.setFieldValue(
                SP_EDIT_FIELDS.LOCATION,
                results[COMMON_CONSTANTS.ZERO].formatted_address
              )
            }
            formik.setFieldValue(
              SP_EDIT_FIELDS.COUNTRY,
              filterCountry[0]?.long_name ? filterCountry[0]?.long_name : "N/A"
            )
          }
        }
      }
    });
  }



  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(false);
    setViewerFile("");
  };

  

  const onPlaceChanged = (formik: any) => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place?.geometry) {
        const location = place?.geometry?.location;
        const lat = location.lat();
        const lng = location.lng();

        setCurrentLatLng(lat, lng);
        getFormattedAddress(lat, lng, formik, false);
        if (inputRef?.current) {
          const inputValue = inputRef.current.value;
          formik.setFieldValue(SP_EDIT_FIELDS.LOCATION, inputValue);
        }
      }
    }
  };

  const onAutocompleteLoad = (autoC: any) => {
    setAutocomplete(autoC);
  };

  return (
    <>
      <FileViewerDialog
        open={fileViewerOpen}
        handleClose={onFilerViewerDialogClose}
        viewerFile={viewerFile}
      ></FileViewerDialog>
      <Formik
        innerRef={formikRef}
        initialValues={TutorDetail}
        onSubmit={(values, actions) => {
          addEditUniversityDetail({...values});
        }}
        enableReinitialize={true}
      >
        {(formik) => (
          <div className="school_fields_container">
            <div className="arrow-wrap">
              <img
                className="school-back"
                onClick={() => {
                  navigate(-1);
                }}
                src={backButton}
                alt="Learn and Play"
              />
              <h5 className="name-title">
                { t("Edit Camp Profile") }
              </h5>
            </div>
            <div className="row school-row-wrap">
              <div id="card-title">{t("Basic Details")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("First Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("First Name")}
                      name={SP_EDIT_FIELDS.FIRST_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.FIRST_NAME] &&
                        formik.errors[SP_EDIT_FIELDS.FIRST_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.FIRST_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Camp Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Camp Name")}
                      name={SP_EDIT_FIELDS.CAMP_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.CAMP_NAME] &&
                        formik.errors[SP_EDIT_FIELDS.CAMP_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.CAMP_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>



                  <div >
                    <label className="fields_label mandatory_fields">{t("Description")}</label>
                    <Field
                      className="description-testarea"
                      placeholder="Enter Description"
                      as="textarea"
                      name={SP_EDIT_FIELDS.DISCRIPTION}
                      rows={4}
                      onKeyPress={(event: any) => {
                        if (250 - formik.values.description.length <= 0)
                          event?.preventDefault();
                      }}
                      onPaste={(event: any) => {
                        const updatedValue =
                          formik.values.description +
                          event.clipboardData.getData("text");
                        if (updatedValue.length > 250) {
                          event.preventDefault();
                        }
                      }}
                    ></Field>
                    <p className="characters-left">
                      {250 - formik.values.description?.length}{" "}
                      {t("characters left")}
                    </p>
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.DISCRIPTION] &&
                        formik.errors[SP_EDIT_FIELDS.DISCRIPTION] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.DISCRIPTION]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrappers">
                    <label className="fields_label mandatory_fields">{t("Location")}</label>
                    <div className="address-wrapper">
                      {isLoaded && (
                        

                        <Autocomplete onLoad={onAutocompleteLoad} onPlaceChanged={() => onPlaceChanged(formik)}>
                          <input
                            type="text"
                            className="auto-complete"
                            placeholder="Enter a place"
                            ref={inputRef}
                            name={SP_EDIT_FIELDS.LOCATION}
                            value={formik.values[SP_EDIT_FIELDS.LOCATION]} 
                            onChange={formik.handleChange}
                          />
                        </Autocomplete>

                      )}
                      {mapEnabled && (
                        <RoomIcon
                          className="room-icon"
                          onClick={() => {
                            setMapEnabled(!mapEnabled);
                          }}
                        />
                      )}
                      {!mapEnabled && (
                        <LocationOffIcon
                          className="room-icon"
                          onClick={() => {
                            setMapEnabled(!mapEnabled);
                          }}
                        />
                      )}
                    </div>
                    {isLoaded && mapEnabled && (
                      <GoogleMap
                        mapContainerClassName="map-container"
                        center={currentLocation}
                        zoom={10}
                      >
                        <MarkerF
                          position={currentLocation}
                          draggable={true}
                          onDragEnd={(e: any) => {
                            setCurrentLatLng(e.latLng.lat(), e.latLng.lng());
                            getFormattedAddress(
                              e.latLng.lat(),
                              e.latLng.lng(),
                              formik, true
                            );
                          }}
                        />
                      </GoogleMap>
                    )}
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.LOCATION] &&
                        formik.errors[SP_EDIT_FIELDS.LOCATION] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[SP_EDIT_FIELDS.LOCATION]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="form-label mandatory_fields">{t("Country")}</label>
                    <Field
                      name={SP_EDIT_FIELDS.COUNTRY}
                      value={formik.values[SP_EDIT_FIELDS.COUNTRY]}
                      onBlur={formik.handleBlur}
                      placeholder={"Country"}
                      className="basic-select-menu"
                      disabled
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.CITY] &&
                        formik.errors[SP_EDIT_FIELDS.CITY] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.CITY]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>


                  <div className="fields_label_wrapper">
                    <label className="form-label">{t("States/Emirates")}</label>
                    <div className="select-wrapper">
                      <Field
                        as="select"
                        name={SP_EDIT_FIELDS.EMIRATES}
                        value={formik.values[SP_EDIT_FIELDS.EMIRATES]}
                        onBlur={formik.handleBlur}
                        className="basic-select-menu"

                        onChange={(e: any) => {
                          formik.setFieldValue(SP_EDIT_FIELDS.EMIRATES, e.target.value)
                        }}
                      >
                        <option value={" "}>{"Please select the emirate"}</option>
                        {formik.values[SP_EDIT_FIELDS.COUNTRY] === 'United Arab Emirates' && emiratesList?.map((item: any) => {
                          return (
                            <option value={item.emirate_city}>{item.emirate_city}</option>
                          )
                        })}
                      </Field>
                    </div>
                    <div className="error-message-wrap">
                      {
                        formik.errors[SP_EDIT_FIELDS.EMIRATES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.EMIRATES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div id="card-wrap">
                  
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Last Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Last Name")}
                      name={SP_EDIT_FIELDS.LAST_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.LAST_NAME] &&
                        formik.errors[SP_EDIT_FIELDS.LAST_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.LAST_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Camp Name Arabic")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Camp Name Arabic")}
                      name={SP_EDIT_FIELDS.ARABIC_CAMP_NAME}
                      dir='rtl'
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.ARABIC_CAMP_NAME] &&
                        formik.errors[SP_EDIT_FIELDS.ARABIC_CAMP_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.ARABIC_CAMP_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div >
                    <label className="fields_label mandatory_fields">{t("About Camp")}</label>
                    <Field
                      className="description-testarea"
                      placeholder="About Camp"
                      as="textarea"
                      name={SP_EDIT_FIELDS.ABOUT_CAMP}
                      rows={4}
                      onKeyPress={(event: any) => {
                        if (250 - formik.values.about_camp.length <= 0)
                          event?.preventDefault();
                      }}
                      onPaste={(event: any) => {
                        const updatedValue =
                          formik.values.about_camp +
                          event.clipboardData.getData("text");
                        if (updatedValue.length > 250) {
                          event.preventDefault();
                        }
                      }}
                    ></Field>
                    <p className="characters-left">
                      {250 - formik.values.about_camp?.length}{" "}
                      {t("characters left")}
                    </p>
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.ABOUT_CAMP] &&
                        formik.errors[SP_EDIT_FIELDS.ABOUT_CAMP] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.ABOUT_CAMP]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">{t("Email")}</label>
                    <Field
                      disabled
                      className="form_inputs"
                      name={SP_EDIT_FIELDS.EMAIL}
                      placeholder="e.g., name@example.com"
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.EMAIL] &&
                        formik.errors[SP_EDIT_FIELDS.EMAIL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.EMAIL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">{t("Phone Number")}</label>
                    <PhoneInput
                      inputProps={{
                        className: "",
                        name: `${SP_EDIT_FIELDS.PHONE_NUMBER}`,
                      }}
                      disabled={true}
                      country={"ae"}
                      enableSearch={true}
                      countryCodeEditable={true} 
                      value={formik.values[SP_EDIT_FIELDS.PHONE_NUMBER]} 
                      onChange={(e) => {
                        formik.setFieldValue(SP_EDIT_FIELDS.PHONE_NUMBER, e);

                        setTimeout(() => {
                          formik.validateField(SP_EDIT_FIELDS.PHONE_NUMBER);
                          setValidNumber(isValidPhoneNumber(e)); 
                        }, 0);
                      }}
                    />
                    <p className="mb-0 phone-validation">{COMMON_CONSTANTS.PHONE_FORMAT}</p>
                    <div className="error-message-wrap">
                      {validNumber === false &&
                        formik.touched[SP_EDIT_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.INVALID_PHONE_NUMBER
                          )}
                        </div>
                      ) : null}
                      {formik.values[SP_EDIT_FIELDS.PHONE_NUMBER] ==
                        "" &&
                        validNumber === true &&
                        formik.touched[SP_EDIT_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.PHONE_NUMBER_REQUIRED
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  
                  <div className="fields_label_wrapper">
                    <label className="form-label">{t("City")}</label>
                    <div className="select-wrapper">
                      <Field
                        as="select"
                        name={SP_EDIT_FIELDS.CITY}
                        value={formik.values[SP_EDIT_FIELDS.CITY]}
                        onBlur={formik.handleBlur}
                        className="basic-select-menu"
                        onChange={(e: any) => {
                          formik.setFieldValue(SP_EDIT_FIELDS.CITY, e.target.value)
                        }}
                      >
                        <option value={" "}>{"Please select the city"}</option>
                        {formik.values[SP_EDIT_FIELDS.COUNTRY] === 'United Arab Emirates' && emiratesList?.map((item: any) => {
                          return (
                            <option value={item.emirate_city}>{item.emirate_city}</option>
                          )
                        })}
                      </Field>
                    </div>


                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.CITY] &&
                        formik.errors[SP_EDIT_FIELDS.CITY] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[SP_EDIT_FIELDS.CITY]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Website Address")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Website Address")}
                      name={SP_EDIT_FIELDS.WEBSITE_ADDRESS}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.WEBSITE_ADDRESS] &&
                        formik.errors[SP_EDIT_FIELDS.WEBSITE_ADDRESS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.WEBSITE_ADDRESS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("PO Code")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("PO Code")}
                      name={SP_EDIT_FIELDS.PINCODE}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.PINCODE] &&
                        formik.errors[SP_EDIT_FIELDS.PINCODE] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.PINCODE
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                </div>
              </div>

              
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Personal Information")}</div>
              {/* ************************Form Content Right*********************** */}
              <div className="col-md-6">

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("ID")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("ID")}
                      name={SP_EDIT_FIELDS.ID}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.ID] &&
                        formik.errors[SP_EDIT_FIELDS.ID] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.ID
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Trade Id")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Trade Id")}
                      name={SP_EDIT_FIELDS.TRADE_ID}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.TRADE_ID] &&
                        formik.errors[SP_EDIT_FIELDS.TRADE_ID] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.TRADE_ID
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Id Front")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "idFront")}
                    ref={idFrontRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => idFrontRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.ID_FRONT] &&
                      formik.errors[SP_EDIT_FIELDS.ID_FRONT] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          SP_EDIT_FIELDS.ID_FRONT
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={idFront}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>
                

                <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Passport Front")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "passportFront")}
                    ref={passportFrontRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => passportFrontRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.PASSPORT_FRONT] &&
                      formik.errors[SP_EDIT_FIELDS.PASSPORT_FRONT] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          SP_EDIT_FIELDS.PASSPORT_FRONT
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={passportFront}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>

                <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Photo")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "photo")}
                    ref={photoRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => photoRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.PHOTO] &&
                      formik.errors[SP_EDIT_FIELDS.PHOTO] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[SP_EDIT_FIELDS.PHOTO]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={photo}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>
              </div>

              {/* ************************For right for fortion*********************** */}
              <div className="col-md-6">
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Passport")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Passport")}
                      name={SP_EDIT_FIELDS.PASSPORT}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[SP_EDIT_FIELDS.PASSPORT] &&
                        formik.errors[SP_EDIT_FIELDS.PASSPORT] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            SP_EDIT_FIELDS.PASSPORT
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>

                  <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Trade License")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "tradeLicense")}
                    ref={tradeLicenseRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => tradeLicenseRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.TRADE_LICENSE] &&
                      formik.errors[SP_EDIT_FIELDS.TRADE_LICENSE] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[SP_EDIT_FIELDS.TRADE_LICENSE]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={tradeLicense}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>
                

                <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Id Back")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "idBack")}
                    ref={idBackRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => idBackRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.ID_BACK] &&
                      formik.errors[SP_EDIT_FIELDS.ID_BACK] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          SP_EDIT_FIELDS.ID_BACK
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={idBack}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>

                <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Passport Back")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "passportBack")}
                    ref={passportBackRef}
                  />
                  <div className="add_images_wrapper" style={{ alignItems: "flex-start" }}>
                    <div
                      className="add_images_cotainer"
                      onClick={() => passportBackRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.PASSPORT_BACK] &&
                      formik.errors[SP_EDIT_FIELDS.PASSPORT_BACK] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          SP_EDIT_FIELDS.PASSPORT_BACK
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-wrap">
                  <img
                    src={passportBack}
                    className="schoolimage-list"
                    alt="Learn and Play"
                  />
                </div>
                </div>

              </div>

              <div className="col-md-12">
              <div className="fields_label_wrapper">
                  <label className="fields_label">
                    {t("Certificates")}
                  </label>
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={(e) => handleFileUpload(e, "certificate")}
                    ref={certificateRef}
                  />
                  <div className="add_images_wrapper">
                    <div
                      className="add_images_cotainer"
                      onClick={() => certificateRef.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[SP_EDIT_FIELDS.CERTIFICATE] &&
                      formik.errors[SP_EDIT_FIELDS.CERTIFICATE] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          SP_EDIT_FIELDS.CERTIFICATE
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-array-wrap">
                  {certificate.map((image: any, index: any) => {
                    return (
                      <div className="image-wrap" key={index}>
                        <img
                          src={image}
                          key={index}
                          className="schoolimage-list"
                          alt="Learn and Play"
                        />
                        <img
                          className="cancel-icon"
                          onClick={handleDelete(index)}
                          src={close}
                          alt="Learn and Play"
                        />
                      </div>
                    );
                  })}
                </div>
               
              </div>
            </div>

            

            <div className="row school-row-wrap">
              
            </div>
            <div className="actions_button_container">
              <button
                className="cancel_button"
                onClick={() => {
                  navigate("/manage-universities");
                }}
              >
                {t("Cancel")}
              </button>
              <button
                className="update_button"
                type="submit"
                onClick={() => {
                  formik.handleSubmit();
                  setFormSubmitted(true);
                }}
              >
                {id ? t("Update") : t("Submit")}
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default ManageEditCamp;
